import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);

  return (
    <div className="min-h-screen bg-[#FDFBF7] text-[#2B3329] flex flex-col">
      <Navbar />
      <main data-testid="site-main" className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
